import { AgTechTabPageFlavorProps, AgTechTabPageTemplate, AgTechTabbedPageTab } from "../../../Pages/Tabbed/AgTechTabPage";

const AgTechThinTabbedPage = (props: AgTechTabPageFlavorProps & {
    tabFontSize?: string
}) => {
    return (
        <AgTechTabPageTemplate
            {...props}
            panel={() => (
                <div className={`wide column-based bottom-bordered container ${props.header?.classes ?? ''}`}>
                      <div className="column-based-vertically-centered flexed container">
                        {props.tabs.map(tab => (
                            <AgTechTabbedPageTab
                                key={tab.text}
                                {...tab}
                                classes={{
                                    tab: `py-1 pb-2 px-5 mb-[-1px] min-w-[72px] font-semibold text-detail centered mr-2 border-b-2 border-b-transparent text-sm div`,
                                    active: 'font-semibold border-b-2 !border-b-highlight !text-primary rounded-none'
                                }}
                            />
                        ))}
                      </div>
                      <div className="ml-auto vertically-centered container">
                          {props.header?.content ? props.header.content() : null}
                      </div>
                  </div>
              )}
        />
    )
}

export default AgTechThinTabbedPage;